/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { Injector, NgModule, importProvidersFrom, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RootComponent, appRoutes as appCMRoutes } from '@frontend/oxygen/cm-routes';
import { CoreModule, GreyhoundService, HorseracingService } from '@frontend/oxygen/core';
import { BannersModule } from '@frontend/oxygen/core-banners';
import { BmaModule } from '@frontend/oxygen/core-bma';
import { provideImageLoader } from '@frontend/oxygen/core-image-loader';
import { VanillaInitModule } from '@frontend/oxygen/core-lib';
import { GREYHOUND_SERVICE, HORSE_RACING_SERVICE } from '@frontend/oxygen/core-racing';
import { SbModule } from '@frontend/oxygen/core-sb';
import { RoutingState, SharedModule } from '@frontend/oxygen/core-shared';
import { lotteriesConfig, sportsConfig, toteClasses } from '@frontend/oxygen/util-env-config';
import { ClientConfigProductName, ProductService, STORE_PREFIX } from '@frontend/vanilla/core';
import { RxVirtualViewObserver } from '@frontend/vanilla/shared/virtual-view';

import { coralProductActivateGuard, coralProductDeactivateGuard } from '../guard';
import { provideCMHostApp } from './host-app.provider';

const CORAL_ROUTES: Routes = [
    {
        path: '',
        canMatch: [coralProductActivateGuard],
        canDeactivate: [coralProductDeactivateGuard],
        children: [...appCMRoutes],
    },
];

@NgModule({
    declarations: [RootComponent],
    imports: [CommonModule, BannersModule, SharedModule, BmaModule, SbModule, RxVirtualViewObserver, RouterModule.forChild(CORAL_ROUTES)],
    exports: [RootComponent],
    providers: [
        provideCMHostApp(),
        provideImageLoader(),
        importProvidersFrom(VanillaInitModule),
        importProvidersFrom(CoreModule),
        { provide: STORE_PREFIX, useValue: 'coralsports.' },
        {
            provide: HORSE_RACING_SERVICE,
            useFactory: () => {
                return inject(HorseracingService);
            },
        },
        {
            provide: GREYHOUND_SERVICE,
            useFactory: () => {
                return inject(GreyhoundService);
            },
        },
    ],
})
export class CMHostAppModule {
    constructor(
        private injector: Injector,
        private routingState: RoutingState,
    ) {
        if (window && !(window as any)['NativeBridge']) {
            // hide static banner image for mobile web n mobile emulator
            const statImg: HTMLElement | null = document.getElementById('statImg');
            if (statImg) {
                statImg.style.display = 'none';
            }
        }
        this.injector.get(ProductService).register(ClientConfigProductName.OZONE, injector);
        let bmaConfig = window && (window as any)['clientConfig']['bmaEnvironmentConfig'];
        const bmaConfiguration = bmaConfig['configuration'];
        bmaConfiguration.CATEGORIES_DATA = sportsConfig;
        bmaConfiguration.LOTTERIES_CONFIG = lotteriesConfig.prod;
        bmaConfiguration.TOTE_CLASSES = toteClasses.prod;
        bmaConfiguration.CURRENT_PLATFORM = 'mobile';
        this.routingState.loadRouting();
    }
}
